import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { useLenis } from "./hooks/useLenis";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { DestinationMarquee } from "./components/Marquee";
import { Manifesto } from "./components/Manifesto";
import { Services } from "./components/Services";
import { Fleet } from "./components/Fleet";
import { Contact, Footer } from "./components/Contact";
import { FloatingContact } from "./components/FloatingContact";
import EktirenPage from "./pages/EktirenPage";

function HomePage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <DestinationMarquee />
        <Services />
        <Manifesto />
        <Fleet />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

function App() {
  useLenis();

  return (
    <LanguageProvider>
      <div className="App" data-testid="app-root">
        <div className="grain-overlay" />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/ektiren" element={<EktirenPage />} />
          </Routes>
          <FloatingContact />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
